import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { verifyPayment } from "../utils/paymentUtil";

const PaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const txnid = searchParams.get("txnid");
  const [status, setStatus] = useState("Verifying payment...");
  const navigate = useNavigate();

  useEffect(() => {
    if (!txnid) {
      setStatus("❌ Invalid transaction ID.");
      alert("❌ Invalid transaction ID.");
      navigate("/subscriptions");
      return;
    }

    const checkPaymentStatus = async () => {
      try {
        const response = await verifyPayment(txnid);
        if (response.success) {
          setStatus("✅ Payment Successful!");
          alert("✅ Payment Successful!");
          navigate("/my-account");
          return true;
        }
      } catch (error) {
        console.error("Error checking payment status:", error);
        alert("❌ Invalid transaction ID.");
        navigate("/subscriptions");
      }
      return false;
    };

    const pollPaymentStatus = () => {
      const interval = setInterval(async () => {
        const success = await checkPaymentStatus();
        if (success) clearInterval(interval); // Stop polling if successful
      }, 5000);

      return () => clearInterval(interval); // Cleanup when component unmounts
    };

    checkPaymentStatus(); // Initial check
    pollPaymentStatus(); // Start polling
  }, [txnid]);

  return <h2>{status}</h2>;
};

export default PaymentStatus;
